<template>
	<div class="profile--thread cursor-pointer" v-on:click="goToThread()">
		<div class="flex justify-between items-center space-x-4 w-full">
			<div class="truncate">
				<div class="flex items-center space-x-2">
					<div
						v-if="unread"
						class="bg-orange-500 rounded-full w-4 h-4 flex-shrink-0"
					></div>
					<p class="font-medium text-gray-900 text-xl truncate">
						<span v-if="thread.counterpart.is_anonymous">*****</span>
						<span class="font-medium text-gray-900 text-xl truncate" v-else>{{
							thread.counterpart.company_name
						}}</span>
					</p>
				</div>

				<p class="truncate">
					{{ productString }} - {{ __("Harvest") }}
					{{ tradable.product.harvest }}
				</p>
			</div>
			<div class="text-gray-400 text-sm text-right">
				<crop-timeago v-bind:date="thread.updated_at" />
				<br />{{ __(statusLabel) }}
			</div>
		</div>

		<div class="flex mt-2 flex-wrap">
			<p class="text-gray-500 text-sm whitespace-nowrap mr-4">
				{{ __("Price") }}:
				{{ $cropOptions.formatLocalizedNumber(tradable.price.mt) }} €/t
			</p>
			<p class="text-gray-500 text-sm whitespace-nowrap">
				{{ __("Quantity") }}: {{ tradable.qty.mt }} t
			</p>
		</div>
		<p class="text-gray-500 text-sm">{{ dateString }}</p>
		<!-- <p class="text-gray-500 text-sm">{{ locationString }}</p> -->
	</div>
</template>

<script>
export default {
	data() {
		return {
			threadStatusOptions: this.$cropOptions.threadStatusOptions,
		};
	},
	props: {
		thread: {
			type: Object,
			required: true,
		},
		referenceTradable: {
			type: Object,
			required: false,
		},
		shouldGoToThread: {
			type: Boolean,
			required: false,
			default: true,
		},
		unread: {
			type: Number,
			required: true,
		},
	},
	computed: {
		tradable: function () {
			if (this.thread.last_tradable) {
				return this.thread.last_tradable;
			}
			let tradable =
				this.thread.bids.length > 0
					? this.thread.bids[0]
					: this.thread.contracts[0];
			return tradable;
		},
		productString() {
			return this.__(
				this.$cropOptions.getLabel(
					this.tradable.product.grade,
					this.$cropOptions.productGradeOptions
				)
			);
		},
		locationString() {
			return this.$cropOptions.locationToString(this.tradable);
		},
		dateString() {
			return this.$cropOptions.dateToString(this.tradable, this.locale);
		},
		threadLink() {
			return window.baseUrl + "/threads?active_id=" + this.thread.id;
		},
		statusLabel() {
			let that = this,
				match = this.threadStatusOptions.filter(
					(o) => that.thread.status == o.id
				)[0];

			return match ? match.name : "";
		},
	},
	methods: {
		goToThread() {
			if (this.shouldGoToThread) {
				window.location = this.threadLink;
			}
		},
	},
};
</script>
